export type WatchlistSystem = 'standard' | 'cloud';

export interface IWatchlistItemPortfolio {
  purchaseDate: number;
  purchasePrice: number;
  purchaseQuantity: number;
}

export interface IWatchlistItem {
  id: number;
  instrument: string;
  portfolio?: IWatchlistItemPortfolio;
}

export interface IWatchlistItems {
  id: number;
  hash: number;
  items: IWatchlistItem[];
}

export interface IWatchlist {
  id: number;
  name: string;
  created: number;
  count: number;
}

export interface IThematicWatchlist {
  id: number;
  name: string;
  description: string;
  descriptionCode: string;
  descriptionUrl: string;
  imageBannerUrl: string;
  imageUrl: string;
  priority: number;
}

export interface IThematicWatchlistDetail {
  hash: number;
  name: string;
  /**
   * @deprecated Use `items` instead as it includes more details.
   */
  instruments: string[];
  items?: CloudApi.SystemWatchlistItemDto[];
}

export namespace CloudApi {
  export interface EmptyBodyModel {}
  export interface RetrieveSystemWatchlistByIdModel {
    id: string;
  }

  export interface SystemWatchlistItemDto {
    instrument: string;
    colourGroup?: number | null;
    selectedForChart: boolean;
  }

  export interface SystemWatchlistDto {
    id: string;
    created: string;
    lastView: string;
    name: string;
    description: string;
    thumbnailUrl: string;
    bannerUrl: string;
    sortOrder: number;
    articleUrl: string;
  }

  export interface SystemWatchlistFullDetailsDto extends SystemWatchlistDto {
    items?: SystemWatchlistItemDto[];
  }

  export interface ICloudThematicWatchlist extends Omit<IThematicWatchlist, 'id'> {
    id: string;
  }
}
